import React from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { globalAction } from '../../store/actions';

import './style.scss';

class Toolbar extends React.Component {
  render() {
    return (
      <div className="toolbar-style">
        {/* <div className="toolbar-item-style first-item-style">
          <svg width="24" height="24" viewBox="0 0 24 24" className="toolbar-icon-style">
            <path fill="#5a585d" d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
          </svg>
        </div> */}
        <div className="toolbar-item-style first-item-style" onClick={this.props.zoomIn}>
          <svg width="24" height="24" viewBox="0 0 24 24" className="toolbar-icon-style">
          <path fill="#5a585d" d="M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z" />
          </svg>
        </div>
        <div className="toolbar-item-style last-item-style" onClick={this.props.zoomOut}>
          <svg width="24" height="24" viewBox="0 0 24 24" className="toolbar-icon-style">
          <path fill="#5a585d" d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z" />
          </svg>
        </div>
        {/* <div className="toolbar-item-style last-item-style" onClick={this.props.reCenter}>
          <svg width="24" height="24" viewBox="0 0 24 24" className="toolbar-icon-style">
          <path fill="#5a585d" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M19,19H15V21H19A2,2 0 0,0 21,19V15H19M19,3H15V5H19V9H21V5A2,2 0 0,0 19,3M5,5H9V3H5A2,2 0 0,0 3,5V9H5M5,15H3V19A2,2 0 0,0 5,21H9V19H5V15Z" />
          </svg>
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  drawerVisibility: state.global.drawerVisibility,
});

Toolbar.propTypes = {
  drawerVisibility: PropTypes.bool.isRequired,
}
export default compose (
  withRouter, 
  connect(mapStateToProps, globalAction)
)(Toolbar);
